module.exports = __webpack_public_path__ + "img/blurmap-VARILUX-COMFORT_full_white.4a208c4d.png";